import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  class: "modal fade",
  ref: "uploadModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_1"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_4 = { class: "modal-content rounded" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header py-2 border-0 justify-content-start",
  style: {"background-color":"#3268ff"}
}, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "fw-bold fs-2",
    style: {"color":"white"}
  }, "Upload")
], -1)
const _hoisted_6 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-5" }
const _hoisted_7 = { class: "row g-9 mb-3 mt-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2 mt-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Pilih Tipe")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "d-flex flex-column mb-3 mt-3 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "text-end fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "Format dokumen .doc , .docx dan .pdf")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2 mt-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Upload Dokumen")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex align-items-center fs-6 fw-bold mb-2 mt-0"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Upload Dokumen Operasional", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = {
  key: 2,
  class: "d-flex align-items-center fs-6 fw-bold mb-2 mt-0"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Upload SK Pengurus", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { style: {"text-align":"end"} }
const _hoisted_27 = ["data-kt-indicator"]
const _hoisted_28 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_30 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_31 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form, {
              id: "kt_modal_1",
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.targetData,
              ref: "formRef",
              class: "form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_el_form_item, {
                    prop: "documentType",
                    class: "mt-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.targetData.documentType,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.documentType) = $event)),
                        placeholder: "Pilih Tipe",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.legalType,
                        searchable: true
                      }, null, 8, ["modelValue", "options"]),
                      (_ctx.targetData.documentType == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.items.errorType), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_form_item, {
                    prop: "file",
                    class: "mt-1"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("input", {
                        name: "file",
                        type: "file",
                        id: "file",
                        class: "form-control form-control-lg",
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFileUpload($event))),
                        key: _ctx.items.fileInputKey
                      }, null, 32)),
                      (_ctx.targetData.file == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.items.errorFile), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.targetData.documentType === 'PKS')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_16, _hoisted_18))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.documentType === 'PKS')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        prop: "file2",
                        class: "mt-1"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("input", {
                            name: "file2",
                            type: "file",
                            id: "file2",
                            class: "form-control form-control-lg",
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFileUpload2($event))),
                            key: _ctx.items.fileInputKey
                          }, null, 32)),
                          (_ctx.targetData.file2 == '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.items.errorFile2), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.documentType === 'PKS')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_21, _hoisted_23))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.documentType === 'PKS')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 3,
                        prop: "file3",
                        class: "mt-1"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("input", {
                            name: "file3",
                            type: "file",
                            id: "file3",
                            class: "form-control form-control-lg",
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleFileUpload3($event))),
                            key: _ctx.items.fileInputKey
                          }, null, 32)),
                          (_ctx.targetData.file3 == '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.items.errorFile3), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger me-3",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.backEvent()))
                  }, " Kembali "),
                  _createElementVNode("button", {
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    class: "btn btn-lg btn-primary",
                    type: "submit"
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("span", _hoisted_30, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _hoisted_34))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_27)
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}